@if (searching()) {
  @let state = searchState();
  @if (!state || state.loading) {
    <div class="flex justify-center py-6">
      <mat-spinner diameter="28"></mat-spinner>
    </div>
  } @else if (state.error) {
    <div class="flex items-center gap-2">
      <span class="text-error-500">{{ "packageCoverage.message.diagnosesSearchError" | translate }}</span>
      <button
        class="cursor-pointer font-bold text-primary-500 hover:text-primary-600"
        type="button"
        (click)="retrySearch.emit(search().trim())"
      >
        {{ "packageConfigurator.action.retry" | translate }}
      </button>
    </div>
  } @else if (hits().length) {
    <section class="flex min-h-0 flex-col overflow-hidden rounded-[18px] border border-neutral-100 bg-neutral-0 shadow-[0_8px_24px_rgb(0_0_0/0.06)]">
      <div [class]="scrollClass()">
        @for (hit of hits(); track hit.code) {
          <insurance-packages-icd10-code-row
            class="pl-3.5 hover:bg-primary-50"
            [code]="hit.code"
            [name]="hit.name"
            [action]="action()"
            [selected]="selectedCodes().has(hit.code)"
            [actionable]="selectedCodes().size === 0"
            (selectedToggle)="toggleSelected(hit.code)"
            (remove)="remove.emit([hit.code])"
          ></insurance-packages-icd10-code-row>
        }
      </div>
    </section>
  } @else {
    <p class="text-neutral-300">{{ "packageCoverage.message.noDiagnosesSearchHits" | translate }}</p>
  }
} @else if (blocksState()?.loading) {
  <div class="flex justify-center py-6">
    <mat-spinner diameter="28"></mat-spinner>
  </div>
} @else {
  <section class="flex min-h-0 flex-col overflow-hidden rounded-[18px] border border-neutral-100 bg-neutral-0 shadow-[0_8px_24px_rgb(0_0_0/0.06)]">
    <div [class]="scrollClass()">
      <insurance-packages-icd10-diagnoses-tree
        [groups]="groups()"
        [names]="names()"
        [loadStates]="nodes()"
        [groupsError]="!!blocksState()?.error"
        [action]="action()"
        [selectedCodes]="selectedCodes()"
        (selectedCodesChange)="selectedCodesChange.emit($event)"
        (remove)="remove.emit($event)"
        (blockOpened)="blockOpened.emit($event)"
        (categoryOpened)="categoryOpened.emit($event)"
        (retry)="retryNode($event)"
        (retryGroups)="retryGroups.emit()"
      ></insurance-packages-icd10-diagnoses-tree>
    </div>
  </section>
}
